import { render, staticRenderFns } from "./Intelligentreporting.vue?vue&type=template&id=4b76f7d0&scoped=true"
import script from "./Intelligentreporting.vue?vue&type=script&lang=js"
export * from "./Intelligentreporting.vue?vue&type=script&lang=js"
import style0 from "./Intelligentreporting.vue?vue&type=style&index=0&id=4b76f7d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b76f7d0",
  null
  
)

export default component.exports